module.exports = __webpack_public_path__ + "components/flag/static/square/uz-a4508a4bd55344e2c8384da1aaaf0f9f.svg";